import { firestore } from "common/Firebase";
import { IWBSCalculateRules } from "common/interfaces";
import { now } from "utils/FirebaseUtils";
import axios from "axios";
import { WBSRows } from "modules/WBS/models";
import { divide, roundBy, subtract, times } from "utils/DecimalUtils";
/**
 * Service de Cálculo da WBS
 * @category Developments
 * @hideconstructor
 */
class CalculateWBSService {
  calculateRowBdi(
    row: WBSRows,
    total: number = 0,
    bdi: number = 0,
    rules: IWBSCalculateRules
  ): { totalSale: number; unitCostSale: number; diffBdi: number } | undefined {
    if (row) {
      const quantity = row.quantity || 0;
      const oldTotalBdi = row.totalBdi || 0;

      // Se o BDI for 0, os valores de venda devem ser iguais aos valores de custo
      let totalSale = total;
      let unitCostSale = totalSale / quantity || 0;
      // Se não recalcula os valores de venda com o BDI
      if (bdi > 0) {
        totalSale = this.calculateBdiTotalSale(total, bdi, rules.roundingRule);
        unitCostSale = quantity == 0 ? 0 : divide(totalSale, quantity);
        unitCostSale = roundBy(unitCostSale, rules);
      }

      const diffBdi = subtract(totalSale, oldTotalBdi);
      return { totalSale, unitCostSale, diffBdi };
    }
    return;
  }

  calculateDiffOfBdiTotalSale(
    bdi: number,
    total: number,
    oldTotal: number,
    roundingRule: string
  ): number {
    const totalBdi = this.calculateBdiTotalSale(total, bdi, roundingRule);
    const oldTotalBdi = this.calculateBdiTotalSale(oldTotal, bdi, roundingRule);
    return totalBdi - oldTotalBdi;
  }

  calculateBdiTotalSale(
    total: number,
    bdi: number,
    roundingRule: string
  ): number {
    const newTotalSale = times(total, 1 + bdi / 100);
    return roundBy(newTotalSale, {
      decimalPlaces: 2,
      roundingRule,
    });
  }

  /**
   * Inicia o processo de recálculo criando um documento na coleção calculateWbs que irá
   * disparar a trigger responsável por obter e recalcular todas as linhas da EAP.
   * @param {Function} onProgress - Função de callback que é executada a cada nova atualização do processo de cálculo
   * @param {Function} onFinished - Função de callback que é executada quando o processo de cálculo é finalizado
   */
  async startCalculating(
    wbsId: string,
    bdiPercentual: number,
    rules: IWBSCalculateRules,
    onProgress: Function,
    onFinished: Function
  ) {
    const wbsBdi = bdiPercentual || 0;

    const doc = this.document(wbsId);
    await doc.set({ wbsId, wbsBdi, rules, createAt: now() });

    this.createSnapshot(wbsId, onProgress, onFinished);

    return axios.post(`${process.env.REACT_APP_CALCULATE_WBS}`, {
      docId: doc.id,
      wbsId,
      wbsBdi,
      rules,
    });
  }

  /**
   * Cria o Snapshot responsável por monitorar o progresso do recálculo da WBS.
   */
  private async createSnapshot(
    wbsId: string,
    onProgress: Function,
    onFinished: Function
  ) {
    const doc = this.document(wbsId);
    let listener = doc.onSnapshot((snapshot) => {
      const data = snapshot.data();
      if (data) {
        if (data.status !== "processed") {
          onProgress(data);
        } else {
          onFinished(data);
          // Cancela snapshot e deleta o documento
          if (listener) listener();
          doc.delete();
        }
      }
    });
  }

  private document(id: string) {
    return firestore.collection("calculateWbs").doc(id);
  }
}

const service = new CalculateWBSService();
export { service as CalculateWBSService };



// WEBPACK FOOTER //
// ./src/modules/WBS/CalculateWBSService.ts